export class ExplanationsSurvey {
  constructor(
    public title: string,
    public questionOptions: string[],
    public answer: string
  ) {}
}
